module.exports = __webpack_public_path__ + "static/media/EYEWEAR.9dfdb148.png";